import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { UpdateUserProfileRequestType } from '../../../services/IbUserAccountsServices/APIService/types';

import { useIbUserAccountsAPIService } from '../useIbUserAccountsAPIService';

interface UseUpdateUserProfileAPIInterface {
  updateUserProfileDetailsAPI: UseMutateAsyncFunction<
    void,
    unknown,
    UpdateUserProfileRequestType,
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useUpdateUserProfileAPI = (): UseUpdateUserProfileAPIInterface => {
  const { ibUserAccountsAPIService } = useIbUserAccountsAPIService();

  const updateUserProfileDetails = (params) => {
    const {
      userId,
      phoneNumber,
      countryCode,
      email,
      profilePicUrl,
      name,
      dob,
      gender,
      preferredLanguages,
      coverPageUrl,
      current_state,
      pincode,
      current_district,
      current_city
    } = params;

    return ibUserAccountsAPIService.updateUserProfile({
      user_id: userId,
      phone_number: phoneNumber,
      country_code: countryCode,
      email,
      profile_pic_url: profilePicUrl,
      name,
      dob,
      gender,
      preferred_languages: preferredLanguages,
      cover_page_url: coverPageUrl,
      current_state,
      state_of_residence: current_state,
      pincode,
      current_district,
      current_city
    });
  };

  const { mutateAsync, error, status } = useMutation(updateUserProfileDetails, {
    mutationKey: ['updateUserProfileDetailsAPI']
  });

  return {
    updateUserProfileDetailsAPI: mutateAsync,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
};

export { useUpdateUserProfileAPI };
